import { useEffect } from 'react';
import { clearPersistedIndexedDB } from 'redux/helpers';

const useVersionCheck = () => {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch('/version.json', { cache: 'no-store' });
        const { version } = await response.json();
        const storedVersion = localStorage.getItem('appVersion');
        if (storedVersion !== version) {
          localStorage.setItem('appVersion', version);
           clearPersistedIndexedDB()
          window.location.reload(true); // Force reload
          
        }
      } catch (error) {
        console.error('Failed to check app version:', error);
      }
    };

    checkVersion(); // Run check on mount
  }, []);
};

export default useVersionCheck;
